import moment from "moment";

/**
 * 어메이징패스(precoupon) 사용가능성 판정 유틸.
 * 기존 AmazingPassItem.jsx 의 검증 로직을 추출해 좌석/패스 자동 배정 플로우에서 재사용한다.
 *
 * "패스 1 = 무료 좌석 1" 모델이므로 할인금액(discount) ≥ 좌석가격 비교는 사용가능 판정에서 제외한다.
 */

// 선택한 상품/날짜에 사용 가능한 패스인지 판정
export function isPassUsable(pass, { product, selectDate } = {}) {
  if (!pass || !product) return false;

  // 1) 미사용 상태만
  if (pass.state !== "사용안함") return false;

  // 2) 만료 안 됨 (expire_date 의 날짜부분만 비교)
  if (pass.expire_date) {
    const today = moment().format("YYYY-MM-DD");
    const expired = today > moment(pass.expire_date.slice(0, 10), "YYYY-MM-DD").format("YYYY-MM-DD");
    if (expired) return false;
  }

  // 3) 쿠폰 사용기간(coupon_start_date ~ coupon_end_date) 내에 선택 날짜가 포함
  if (selectDate && pass.coupon_start_date && pass.coupon_end_date) {
    const dateValid = moment(selectDate).isBetween(
      moment(pass.coupon_start_date).startOf("day"),
      moment(pass.coupon_end_date).endOf("day"),
      null,
      "[]"
    );
    if (!dateValid) return false;
  }

  // 4) 해당 패키지에 사용 가능
  if (!pass.available_packages?.includes(product.id)) return false;

  return true;
}

// 사용 가능한 패스만 필터링
export function filterUsablePasses(passes = [], context = {}) {
  return passes.filter((pass) => isPassUsable(pass, context));
}

// 만료 임박(expire_date 오름차순) 순으로 정렬 — 만료일이 가까운 패스부터 소진
export function sortByExpiryAsc(passes = []) {
  return [...passes].sort((a, b) => {
    const aDate = a?.expire_date ? moment(a.expire_date).valueOf() : Infinity;
    const bDate = b?.expire_date ? moment(b.expire_date).valueOf() : Infinity;
    return aDate - bDate;
  });
}

// 사용 가능 패스를 만료 임박 순으로 정렬해 반환 (필터 + 정렬 조합)
export function getUsablePassesSorted(passes = [], context = {}) {
  return sortByExpiryAsc(filterUsablePasses(passes, context));
}
